// extracted by mini-css-extract-plugin
export default {"title":"MyReview_title__R+baw","categoryWrap":"MyReview_categoryWrap__UP0kg","hit":"MyReview_hit__efyZV"};